var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-732 -565) translate(631 371) translate(102 194) translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.8,
    cy: 16.8,
    r: 16.8,
    stroke: "#E5E7DF",
    strokeWidth: 0.843
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CAEB4",
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M24.2 12.138L17 18.697l-7.2-6.568v-.262h14.4v.271zM9.8 22.133v-7.518l7.2 6.566 7.2-6.558v7.51H9.8zm-1.8.575C8 23.422 8.579 24 9.295 24h15.41C25.42 24 26 23.434 26 22.708V11.292c0-.714-.579-1.292-1.295-1.292H9.295C8.58 10 8 10.566 8 11.292v11.416z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmail);
export default __webpack_public_path__ + "static/media/contact-email.1428e369712c9d92d9050c492a96b8b2.svg";
export { ForwardRef as ReactComponent };